import { Component } from '@angular/core';

@Component({
  templateUrl: './about.component.html',
})
export class AboutComponent {

}



// WEBPACK FOOTER //
// ./src/app/marketing/about.component.ts